import React, { useState } from "react";

import TextInput from "./components/TextInput";
import Button from "./components/Button";
import './styles.css';
const App = () => {
  const [albumin, setAlbumin] = useState();
  const [age, setAge] = useState();
  const [ast, setAst] = useState();
  const [plt, setPlt] = useState();
  const [alt, setAlt] = useState();

  const [fib5, setFib5] = useState();
  const [fib5Class, setFib5Class] = useState();

  const handleAlbuminChange = (event) => setAlbumin(event.target.value);
  const handleAgeChange = (event) => setAge(event.target.value);
  const handleAstChange = (event) => setAst(event.target.value);
  const handlePltChange = (event) => setPlt(event.target.value);
  const handleAltChange = (event) => setAlt(event.target.value);

  const computeFib5 = () => {
    let fib5Value = (0.7207-(0.6729*albumin)+(0.4408*((age*ast)/(plt*alt^0.5)))).toFixed(2);
    setFib5(fib5Value);
    let fib5Class = getFib5(fib5Value);
    setFib5Class(fib5Class);

    setAlbumin("")
    setAge("")
    setAst("")
    setPlt("")
    setAlt("")
    
  };

  const getFib5 = (fib5) => {
    
    if (fib5 < 18.5) {
      return "Underweight";
    }
    if (fib5 >= 18.5 && fib5 < 24.9) {
      return "Normal weight";
    }
    if (fib5 >= 25 && fib5 < 29.9) {
      return "Overweight";
    }
    if (fib5 >= 30) {
      return "Obesity";
    }
  };

  return (
    <div className="App">
    <div className="container">
      <div
        style={{
          display: "block",
          width: "50%",
          margin: "0 auto",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <h2>Welcome to the Fib-5 Calculator!</h2>
        <h3>This Website provides a Fib-5 Calculator for blah blah </h3>
        <h4>For more information please go to www.journal.com to read the article by Rabiee et al</h4>
      </div>
      <div className="row">
        <TextInput
          label="Albumin"
          placeholder="Enter Albumin in IU/L"
          handleChange={handleAlbuminChange}
          value={albumin}
        />
      </div>

      <div className="row">
        <TextInput
          label="Age"
          placeholder="Enter Age in Years"
          handleChange={handleAgeChange}
          value={age}          
        />
      </div>

       <div className="row">
        <TextInput
          label="AST"
          placeholder="Enter AST in IU/L"
          handleChange={handleAstChange}
          value={ast}          
        />
       </div>
  
        <div className="row">
        <TextInput
          label="Platelets"
          placeholder="Enter platelets in 10E3/L"
          handleChange={handlePltChange}
          value={plt}          
        />
      </div>

        <div className="row">
        <TextInput
          label="ALT"
          placeholder="Enter ALT in IU/L"
          handleChange={handleAltChange}
          value={alt}          
        />     
      </div>

      <div className="button">
        <Button label="CALCULATE" onClick={computeFib5} />
      </div>
      
      <div className="row">
        {
          isNaN(fib5)?null:<h3>Your Fib-5 = {fib5}</h3> 
        }
        
      </div>
      <div className="row">
        <h3>{fib5Class}</h3>
      </div>
    </div>
    </div>
  );
};

export default App;
